import { svgDataUri } from '../shared'

export const ICON_USER = svgDataUri(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><circle cx="12" cy="8" r="4" fill="#7B8CAA"/><path d="M4 21 C4 15.5 7.5 13 12 13 C16.5 13 20 15.5 20 21 Z" fill="#7B8CAA"/></svg>'
)

export const demoUser = {
  uuid: 'demo-user-uuid',
  lockVersion: 1,
  name: '鈴木 一郎',
  code: 'demo-user',
  email: 'demo-user@example.com',
  iconUrl: ICON_USER,
  lastLoginAt: 0,
  lastLogoutAt: 0,
}

// demoUser以外にもユーザーを用意し、ユーザー画面やProjectMember画面の
// ユーザーピッカーに複数の選択肢を持たせる。追加・編集・削除の保存が
// 空っぽの状態ではなく実際の操作らしく見えるようにするため。
export const baseUserDetail = {
  lockVersion: 1,
  revision: 'demo-revision',
  children: [] as any[],
  nameKana: '',
  nameAlphabet: '',
  phoneNumber: '',
  birthday: '',
  division: undefined,
  position: undefined,
  hireDate: '',
  leaveDate: '',
  validFrom: 0,
  validTo: 0,
  emailNotification: false,
  role: { uuid: 'demo-role-member', code: 'MEMBER', name: 'メンバー' },
  timezoneId: 'Asia/Tokyo',
  oneTimeTokenExpiredAt: 0,
  temporaryPasswordExpiredAt: 0,
  lastLoginAt: '',
  lastAccessAt: '',
  registrationStatus: 'FINAL',
  changingEmailStatus: 'FINAL',
  temporaryPasswordStatus: 'FINAL',
  partnerMember: false,
}

export const demoUsersByUuid: { [uuid: string]: any } = {
  [demoUser.uuid]: {
    ...baseUserDetail,
    uuid: demoUser.uuid,
    code: demoUser.code,
    name: demoUser.name,
    email: demoUser.email,
    iconUrl: demoUser.iconUrl,
    role: { uuid: 'demo-role-admin', code: 'ADMIN', name: '管理者' },
  },
  'demo-user-2': {
    ...baseUserDetail,
    uuid: 'demo-user-2',
    code: 'demo-user-2',
    name: '山田 太郎',
    email: 'yamada@example.com',
    iconUrl: ICON_USER,
  },
  'demo-user-3': {
    ...baseUserDetail,
    uuid: 'demo-user-3',
    code: 'demo-user-3',
    name: '佐藤 花子',
    email: 'sato@example.com',
    iconUrl: ICON_USER,
  },
}
